import { useLayoutEffect, useRef, useState } from "react";
import { SxProps, Theme, Tooltip, Typography } from "@mui/material";

/**
 * For this component to work properly its's parent should have a display: "flex" and the desired maxWidth.
 * For better results use the ResizeObverser hook to truncate the text according to the available space.
 */
const TruncatedText = ({
    width,
    children,
    sx,
}: {
    width: number | undefined;
    children: string;
    sx?: SxProps<Theme>;
}) => {
    const ref = useRef<HTMLDivElement>(null);
    const [shouldShowTooltip, setShouldShowTooltip] = useState(false);

    useLayoutEffect(() => {
        if (ref.current === null) return;
        setShouldShowTooltip(ref.current?.scrollWidth > ref.current?.clientWidth);
    }, [width]);

    const Text = (
        <Typography
            ref={ref}
            sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "pre",
                flex: 1,
                ...sx,
            }}
        >
            {children}
        </Typography>
    );

    return shouldShowTooltip ? (
        <Tooltip arrow placement="top-start" title={children}>
            {Text}
        </Tooltip>
    ) : (
        Text
    );
};

export default TruncatedText;
